const API = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Converts a storage path to an accessible preview/download URL.
 * If it's already a full URL, returns as-is.
 * If it's a storage path, wraps it with the /api/files/ proxy.
 */
export function getFileUrl(path) {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  if (path.startsWith('/api/')) return process.env.REACT_APP_BACKEND_URL + path;
  return `${API}/files/${path}`;
}

/**
 * Returns true if the file can be previewed inline (PDF or image)
 */
export function canPreview(path) {
  if (!path) return false;
  const lower = path.toLowerCase();
  return lower.endsWith('.pdf') || lower.endsWith('.jpg') || lower.endsWith('.jpeg') || lower.endsWith('.png') || lower.endsWith('.gif') || lower.endsWith('.webp') || lower.endsWith('.svg');
}

/**
 * Returns true if the file is a PDF
 */
export function isPdf(path) {
  return path?.toLowerCase().endsWith('.pdf');
}

/**
 * Returns true if the file is an image
 */
export function isImage(path) {
  if (!path) return false;
  const lower = path.toLowerCase();
  return lower.endsWith('.jpg') || lower.endsWith('.jpeg') || lower.endsWith('.png') || lower.endsWith('.gif') || lower.endsWith('.webp') || lower.endsWith('.svg');
}
